import React from 'react';
import { DefaultRoute, Route } from 'react-router';
import { MODULE, PERMISSION, SECURABLE_TYPE, TSECURABLE } from 'core/metamodel/metaConstant';
import Application from 'core/components/application/application';
import Home from 'core/components/home/home';
import CustomerList from 'party/page/customerList';
import ContactPersonList from 'party/page/contactPersonList';
import SalesRepList from 'party/page/salesRepList';
import PartyList from 'party/page/partyList';
import PartyDetail from 'party/page/partyDetail';
import IssuedInvoiceList from 'invoice/page/issuedInvoiceList';
import InvoiceDetail from 'invoice/page/invoiceDetail';
import VehicleList from 'product/page/vehicleList';
import VehicleDetail from 'product/page/vehicleDetail';
import ProductList from 'product/page/productList';
import ProductDetail from 'product/page/productDetail';
import PriceComponentList from 'product/page/priceComponentList';
import PriceComponentDetail from 'product/page/priceComponentDetail';
import UserList from 'core/security/userList';
import UserDetail from 'core/security/userDetail';
import UserProfile from 'core/security/userProfile';
import SetPassword from 'core/security/setPassword';
import SecurityRoleList from 'core/security/securityRoleList';
import SecurityRoleDetail from 'core/security/securityRoleDetail';
import LoginPage from 'core/security/loginPage';
import EntityList from 'core/metamodel/entityList';
import EntityDetail from 'core/metamodel/entityDetail';
import EntityFieldDetail from 'core/metamodel/entityFieldDetail';
import JobList from 'core/job/jobList';
import JobDetail from 'core/job/jobDetail';
import GridLocationList from 'core/grid/gridLocationList';
import GridLocationDetail from 'core/grid/gridLocationDetail';
import GridConfigDetail from 'core/grid/gridConfigDetail';
import GridSpecialConditionDetail from 'core/grid/gridSpecialConditionDetail';
import DocumentTypeList from 'core/document/documentTypeList';
import DocumentTypeDetail from 'core/document/documentTypeDetail';
import DocumentTemplateDetail from 'core/document/documentTemplateDetail';
import EventTypeList from 'core/event/eventTypeList';
import EventTypeDetail from 'core/event/eventTypeDetail';
import EventTemplateDetail from 'core/event/eventTemplateDetail';
import GridAdminView from 'core/grid/component/gridAdminView';
import ResponsiveTest from 'administration/responsiveTest';
import ServerOverview from 'administration/server/serverOverview';
import ActivityConfigList from 'core/event/activityConfigList';
import ActivityConfigDetail from 'core/event/activityConfigDetail';
import ActivityTemplateDetail from 'core/event/activityTemplateDetail';
import TaskDetail from 'core/event/taskDetail';
import TaskList from 'core/event/taskList';
import ActivityList from 'core/event/activityList';
import ContractDetail from 'core/document/contractDetail';
import ContractList from 'core/document/contractList';
import ReferenceList from 'administration/referenceTables/referenceList';
import ReferenceDetail from 'administration/referenceTables/referenceDetail';
import InvoiceTemplateList from 'invoice/page/invoiceTemplateList';
import InvoiceTemplateDetail from 'invoice/page/invoiceTemplateDetail';
import CertificateList from 'administration/certificate/certificateList';
import CertificateDetail from 'administration/certificate/CertificateDetail';
import BankTransactionList from 'accounting/page/bankTransactionList';
import AddressPlacesList from 'party/page/addressPlacestList';
import ShipmentOutgoingList from 'shipment/page/shipmentOutgoingList';
import ShipmentIncomingList from 'shipment/page/shipmentIncomingList';
import ShipmentDetail from 'shipment/page/shipmentDetail';
import ShipmentRepackagingList from 'shipment/page/shipmentRepackagingList';
import ShipmentRepackagingDetail from 'shipment/page/shipmentRepackagingDetail';
import ShipmentVisitList from 'shipment/page/shipmentVisitList';
import ShipmentVisitDetail from 'shipment/page/shipmentVisitDetail';
import SupplierList from 'party/page/supplierList';
import EventList from 'core/event/eventList';
import ShipmentReport from 'shipment/page/shipmentReport';
import InvoiceReport from 'invoice/page/invoiceReport';
import TimeSheetReport from 'humanresource/page/timeSheetReport';
import GridLocationFieldDetail from 'core/grid/gridLocationFieldDetail';
import EntityNumberGenGroupList from './invoice/page/entityNumberGenGroupList';
import EntityNumberGenGroupDetail from './invoice/page/entityNumberGenGroupDetail';
import CriteriaList from './sbtool/page/criterion/criteriaList';
import CriterionDetail from './sbtool/page/criterion/criterionDetail';
import ProjectsList from './sbtool/page/project/projectsList';
import ProjectDetail from './sbtool/page/project/projectDetail';
import SbToolSubCriterionDetail from './sbtool/page/criterion/subCriterionDetail';
import ProjectVersionDetail from './sbtool/page/project/projectVersionDetail';
import MaterialsList from './sbtool/page/material/materialsList';
import EnergyCarriersList from './sbtool/page/material/energyCarriersList';
import LifespanList from './sbtool/page/material/lifespanList';
import ProjectVersionRoomList from './sbtool/page/project/roomTypesList';
import MaterialUsageGroupsList from './sbtool/page/material/materialUsageGroupsList';
import AreaList from './sbtool/page/project/areaList';
import ParamKeyList from './core/tenant/paramkey/paramKeyList';
import ParamKeyDetail from './core/tenant/paramkey/paramKeyDetail';
import HaulerList from 'party/page/haulerList';
import DriverList from 'party/page/driverList';
import BrimMessageList from 'core/dataimport/page/brimMessagesList';


export interface PageDefProps {
  path: string;
  handler: any;
  name: string|TSECURABLE;
  module: MODULE;
  type?: SECURABLE_TYPE;
  permission?: PERMISSION;
}

const pages: PageDefProps[] = [

  {name: "loginPage", path: "login", module: MODULE.core, handler: LoginPage},
  {name: "entityList", path: "core/entity/:gridId?", module: MODULE.core, handler: EntityList},
  {name: "entityDetail", path: "core/entity/detail/:id", module: MODULE.core, handler: EntityDetail},
  {name: "entityFieldDetail", path: "core/entity/field/:id", module: MODULE.core, handler: EntityFieldDetail},
  {name: "gridLocationList", path: "core/grid-location/:gridId?", module: MODULE.core, handler: GridLocationList},
  {name: "gridLocationDetail", path: "core/grid-location/detail/:id?", module: MODULE.core, handler: GridLocationDetail},
  {name: "gridConfigDetail", path: "core/grid-config/detail/:id", module: MODULE.core, handler: GridConfigDetail},
  {name: "gridSpecialConditionDetail", path: "core/grid-special-condition/:id", module: MODULE.core, handler: GridSpecialConditionDetail},
  {name: "gridLocationFieldDetail", path: "core/grid-location/field/:id", module: MODULE.core, handler: GridLocationFieldDetail},


  {name: "documentTypeList", path: "core/document-type/grid/:gridId?", module: MODULE.core, handler: DocumentTypeList},
  {name: "documentTypeDetail", path: "core/document-type/detail/:id", module: MODULE.core, handler: DocumentTypeDetail},
  {name: "documentTemplateDetail", path: "core/document-type/template/:id", module: MODULE.core, handler: DocumentTemplateDetail},

  {name: "eventTypeList", path: "core/event-type/grid/:gridId?", module: MODULE.core, handler: EventTypeList},
  {name: "eventTypeDetail", path: "core/event-type/detail/:id", module: MODULE.core, handler: EventTypeDetail},
  {name: "eventTemplateDetail", path: "core/event-type/template/:id", module: MODULE.core, handler: EventTemplateDetail},

  {name: "activityConfigList", path: "core/activity-config/grid/:gridId?", module: MODULE.core, handler: ActivityConfigList},
  {name: "activityConfigDetail", path: "core/activity-config/detail/:id", module: MODULE.core, handler: ActivityConfigDetail},
  {name: "activityTemplateDetail", path: "core/activity-config/template/:id", module: MODULE.core, handler: ActivityTemplateDetail},

  {name: "activityList", path: "activity/grid/:gridId?", module: MODULE.core, handler: ActivityList},
  {name: "eventList", path: "event/grid/:gridId?", module: MODULE.core, handler: EventList},
  {name: "taskList", path: "task/grid/:gridId?", module: MODULE.core, handler: TaskList},
  {name: "taskDetail", path: "task/detail/:id", module: MODULE.core, handler: TaskDetail},
  {name: "contractList", path: "contract/grid/:gridId?", module: MODULE.core, handler: ContractList},
  {name: "contractDetail", path: "contract/detail/:id", module: MODULE.core, handler: ContractDetail},

  {name: "jobList", path: "core/job/:gridId?", module: MODULE.core, handler: JobList},
  {name: "jobDetail", path: "core/job/detail/:id", module: MODULE.core, handler: JobDetail},


  {name: "partyCustomers", path: "party/grid/customer/:gridId?", module: MODULE.party, handler: CustomerList},
  {name: "partyContacts", path: "party/grid/contact-person/:gridId?", module: MODULE.party, handler: ContactPersonList},
  {name: "partySalesReps", path: "party/grid/sales-rep/:gridId?", module: MODULE.party, handler: SalesRepList},
  {name: "partySuppliers", path: "party/grid/supplier/:gridId?", module: MODULE.party, handler: SupplierList},
  {name: "partyHaulers", path: "party/grid/hauler/:gridId?", module: MODULE.party, handler: HaulerList},
  {name: "partyDrivers", path: "party/grid/driver/:gridId?", module: MODULE.party, handler: DriverList},
  {name: "partyAll", path: "party/grid/all/:gridId?", module: MODULE.party, handler: PartyList},
  {name: "partyDetail", path: "party/detail/:id", module: MODULE.party, handler: PartyDetail},
  {name: "addressPlacesList", path: "party/address-places/:id", module: MODULE.party, handler: AddressPlacesList},


  {name: "issuedInvoiceList", path: "issued-invoice/grid/:gridId?", module: MODULE.invoicing, handler: IssuedInvoiceList},
  {name: "invoiceTemplateList", path: "invoice-template/grid/:gridId?", module: MODULE.invoicing, handler: InvoiceTemplateList},
  {name: "invoiceDetail", path: "invoice/detail/:id", module: MODULE.invoicing, handler: InvoiceDetail},
  {name: "invoiceTemplateDetail", path: "invoice-template/detail/:id", module: MODULE.invoicing, handler: InvoiceTemplateDetail},
  {name: "invoiceReport", path: "invoice-report/grid/:gridId?", module: MODULE.invoicing, handler: InvoiceReport},

  {name: "entityNumberGenGroupList", path: "entity-number-gen-group/grid/:gridId?", module: MODULE.invoicing, handler: EntityNumberGenGroupList},
  {name: "entityNumberGenGroupDetail", path: "entity-number-gen-group/detail/:id", module: MODULE.invoicing, handler: EntityNumberGenGroupDetail},

  {name: "bankTransactionList", path: "bank-transaction-account/grid/:id/:gridId?", module: MODULE.accounting, handler: BankTransactionList},

  {name: "vehicleList", path: "vehicle/grid/:gridId?", module: MODULE.product, handler: VehicleList},
  {name: "vehicleDetail", path: "vehicle/detail/:id", module: MODULE.product, handler: VehicleDetail},
  
  {name: "brimMessageList", path: "brim-messages/grid/:gridId?", module: MODULE.product, handler: BrimMessageList},

  {name: "productList", path: "product/grid/:gridId?", module: MODULE.product, handler: ProductList},
  {name: "productDetail", path: "product/detail/:id", module: MODULE.product, handler: ProductDetail},

  {name: "priceComponentList", path: "price/grid/:gridId?", module: MODULE.product, handler: PriceComponentList},
  {name: "priceComponentDetail", path: "price/detail/:id", module: MODULE.product, handler: PriceComponentDetail},

  {name: "shipmentOutgoingList", path: "shipment-outgoing/grid/:gridId?", module: MODULE.shipment, handler: ShipmentOutgoingList},
  {name: "shipmentIncomingList", path: "shipment-incoming/grid/:gridId?", module: MODULE.shipment, handler: ShipmentIncomingList},
  {name: "shipmentDetail", path: "shipment/detail/:id", module: MODULE.shipment, handler: ShipmentDetail},
  {name: "shipmentRepackagingList", path: "shipment-repackaging/grid/:gridId?", module: MODULE.shipment, handler: ShipmentRepackagingList},
  {name: "shipmentRepackagingDetail", path: "shipment-repackaging/detail/:id", module: MODULE.shipment, handler: ShipmentRepackagingDetail},
  {name: "shipmentVisitList", path: "shipment-visit/grid/:gridId?", module: MODULE.shipment, handler: ShipmentVisitList},
  {name: "shipmentVisitDetail", path: "shipment-visit/detail/:id", module: MODULE.shipment, handler: ShipmentVisitDetail},
  {name: "shipmentReport", path: "shipment-report/grid/:gridId?", module: MODULE.shipment, handler: ShipmentReport},

  {name: "timeSheetReport", path: "time-sheet-report/grid/:gridId?", module: MODULE.humanresource, handler: TimeSheetReport},

  {name: "userList", path: "user/grid/:gridId?", module: MODULE.core, handler: UserList},
  {name: "userDetail", path: "user/detail/:id", module: MODULE.core, handler: UserDetail},
  {name: "userProfile", path: "user/profile/:tab?", module: MODULE.core, handler: UserProfile},
  {name: "setPassword", path: "user/set-password/:mode/:id?", module: MODULE.core, handler: SetPassword},
  {name: "securityRoleList", path: "security-role/grid/:gridId?", module: MODULE.core, handler: SecurityRoleList},
  {name: "securityRoleDetail", path: "security-role/detail/:id", module: MODULE.core, handler: SecurityRoleDetail},

  {name: "serverOverview", path: "administration/server/:tab?", module: MODULE.core, handler: ServerOverview},
  {name: "referenceList", path: "administration/reference-list", module: MODULE.core, handler: ReferenceList},
  {name: "referenceDetail", path: "administration/reference-detail/:id/:gridId?", module: MODULE.core, handler: ReferenceDetail},

  {name: "certificateList", path: "administration/certificate/grid/:gridId?", module: MODULE.core, handler: CertificateList},
  {name: "certificateDetail", path: "administration/certificate/detail/:id", module: MODULE.core, handler: CertificateDetail},


  {name: "gridAdmin", path: "core/grid/admin/:gridLocation/:gridId?", module: MODULE.core, handler: GridAdminView},

  {name: "responsiveTest", path: "administration/responsive-test", module: MODULE.core, handler: ResponsiveTest},


  {name: "sbToolCriteriaList", path: "sbtool/criteria-page/grid/:gridId?", module: MODULE.sbtool, handler: CriteriaList},
  {name: "sbToolCriteriaDetail", path: "sbtool/criteria-page/detail/:id", module: MODULE.sbtool, handler: CriterionDetail},
  {name: "sbToolSubCriterionDetail", path: "sbtool/sub-criteria-page/detail/:id", module: MODULE.sbtool, handler: SbToolSubCriterionDetail},

  {name: "sbToolProjectsList", path: "sbtool/projects-page/grid/:gridId?", module: MODULE.sbtool, handler: ProjectsList},
  {name: "sbToolProjectDetail", path: "sbtool/projects-page/detail/:id", module: MODULE.sbtool, handler: ProjectDetail},
  {name: "sbToolProjectVersionDetail", path: "sbtool/project-versions-page/detail/:id", module: MODULE.sbtool, handler: ProjectVersionDetail},

  {name: "sbToolMaterialsList", path: "sbtool/materials-page/grid/:gridId?", module: MODULE.sbtool, handler: MaterialsList},
  {name: "sbToolEnergyCarriersList", path: "sbtool/energy-carriers-page/grid/:gridId?", module: MODULE.sbtool, handler: EnergyCarriersList},
  {name: "sbToolLifespanList", path: "sbtool/lifespan-page/grid/:gridId?", module: MODULE.sbtool, handler: LifespanList},

  {name: "sbToolRoomTypeList", path: "sbtool/room-types-page/grid/:gridId?", module: MODULE.sbtool, handler: ProjectVersionRoomList},
  {name: "sbToolMaterialUsageGroupList", path: "sbtool/material-usage-groups-page/grid/:gridId?", module: MODULE.sbtool, handler: MaterialUsageGroupsList},
  {name: "sbToolAreaList", path: "sbtool/areas-page/grid/:gridId?", module: MODULE.sbtool, handler: AreaList},

  {name: "paramKeyList", path: "param-key/grid/:gridId?", module: MODULE.core, handler: ParamKeyList},
  {name: "paramKeyDetail", path: "param-key/detail/:id", module: MODULE.core, handler: ParamKeyDetail},

];

export const PAGE: {[key: string]: PageDefProps} = pages.reduce((acc, value) => {
  value.type = SECURABLE_TYPE.PAGE;
  acc[value.name] = value;
  return acc;
}, {});


export const routes = (
  <Route path="/" handler={Application}>
    <DefaultRoute name="home" handler={Home}/>
    {pages.map((page, index) => <Route key={index} name={page.name} path={page.path} handler={page.handler}/>)}
  </Route>
);




// WEBPACK FOOTER //
// ./src/routes.tsx